import { Link } from 'react-router-dom'
import { ExternalLink, Sparkles } from 'lucide-react'
import { canAccessPath, isRoleAllowedForPath } from '../../../../app/access'
import { jobDetailsHref } from '../../../layout-generator/jobLogic'

interface Props {
  /** `ai_layout_job_id` макета: задание генератора, из которого он создан. Пусто — макет не из генератора. */
  jobId?: string | null
  jobName?: string | null
  /** У задания заполнен `deleted_at`. */
  deleted?: boolean
  permissions: readonly string[]
  role?: string | null
}

/**
 * Строка «Создан в генераторе макетов: задание «…»» в карточке макета (SPEC_2026-10-03 §4.5 п.3).
 * Ссылка ведёт на страницу задания, только если у пользователя есть доступ к `/layout-generator`
 * (право и роль из `app/access.ts`); иначе показывается тот же текст без ссылки. Удалённое задание
 * называется «задание удалено» и ссылки не даёт.
 */
export function AiLayoutSourceNote({ jobId, jobName, deleted = false, permissions, role }: Props) {
  if (!jobId) return null
  const href = jobDetailsHref({ id: jobId, method: 'studio' })
  const canOpen = !deleted && canAccessPath(href, permissions) && isRoleAllowedForPath(href, role)
  const title = (jobName || '').trim() || 'без названия'

  return (
    <div
      data-testid="ai-layout-source-note"
      className="flex items-start gap-1.5 rounded-md border border-gray-200 bg-white px-2.5 py-1.5 text-xs text-gray-600 dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-300"
    >
      <Sparkles className="mt-0.5 h-3.5 w-3.5 shrink-0 text-indigo-500 dark:text-indigo-400" aria-hidden="true" />
      <p className="min-w-0">
        Создан в генераторе макетов:{' '}
        {deleted ? (
          'задание удалено'
        ) : canOpen ? (
          <Link
            to={href}
            title="Открыть задание генератора"
            className="inline-flex max-w-full items-center gap-1 font-medium text-indigo-600 hover:text-indigo-500 hover:underline dark:text-indigo-400"
          >
            <span className="truncate">{`задание «${title}»`}</span>
            <ExternalLink className="h-3 w-3 shrink-0" aria-hidden="true" />
          </Link>
        ) : (
          <span className="font-medium">{`задание «${title}»`}</span>
        )}
      </p>
    </div>
  )
}
